import {useStatic} from "@/store/static"
import {useNuxtApp} from '#app'

export const processes: TableModule = {
    name: "processes",
    route: "spa.processes.processes",
    defaultOrder: {
        column: "id",
        direction: "desc"
    },
    columns: [
        {
            name: "process_number",
            sortable: true,
            pageLink: true,
            sortBy: "customOrderProcessNumber",
            mobile: true,
            width: "w-[220px]",
        }, {
            name: "event",
            sortable: true,
            sortBy: "events.start_date",
            breakpoint: 'xl',
        }, {
            name: "country",
            sortable: true,
            sortBy: "events.country",
            hidden: true
        }, {
            name: "organisation",
            sortable: true,
            sortBy: "organisation_id",
            width: "w-1/4 sm:w-auto",
            breakpoint: 'lg',
        }, {
            name: "funding_program",
            sortable: true,
            sortBy: "funding_program_id",
            breakpoint: 'lg',
        }, {
            name: "partner_country",
            sortable: true,
            sortBy: "customOrderPartnerCountry",
            breakpoint: 'lg'
        }, {
            name: "subsidy_amount",
            sortable: true,
            sortBy: "subsidy_open_payment",
            width: "w-[135px]"
        }, {
            name: "formProcesses",
            width: "w-[90px]"
        }, {
            name: "status",
            sortable: true,
            sortBy: "status_id",
            width: "w-[150px]"
        }, {
            name: "symbols",
            mobile: true,
            width: "min-w-[100px]",
            headerClass: "block sm:hidden",
            cellClass: "min-w-[100px] block sm:hidden"
        }
    ],
    filters: [
        {
            name: "year",
            column: "processes.year_id",
            type: "select",
            options: computed(() => {
                const staticStore = useStatic()
                return reactive(staticStore?.years?.map((year: any) => {
                    return {
                        value: year.id,
                        label: year.id
                    }
                }) || [])
            }),
            reduced: true,
        }, {
            name: "organisation",
            column: "processes.organisation_id",
            type: "searchSelect",
            apiRoute: "spa.settings.organisations.index",
            reduced: 'in',
            searchThreshold: 1,
            additionalDisplayKey: 'additionalInfo',
        }, {
            name: "fundingProgram",
            column: "customFilterFundingPrograms",
            type: "searchSelect",
            apiRoute: "spa.basedata.fundingPrograms.filterOptions",
            reduced: 'in',
            additionalDisplayKey: 'parent_funding_program_name',
            additionalDisplayPosition: 'above',
            searchSelectConfig: {
                fetchOnSearch: false,
                orderBy: 'customOrderSortByParent',
                orderDirection: 'asc',
            }
        }, {
            name: "country",
            column: "events.country",
            type: "searchSelect",
            options: computed(() => {
                const staticStore = useStatic()
                return reactive(staticStore?.formCountries?.map((country: any) => {
                    return {
                        id: country.code,
                        name: country.name
                    }
                }) || [])
            }),
            reduced: 'in',
            searchSelectConfig: {
                fetchOnSearch: false,
                displayKey: 'label'
            }
        }, {
            name: "partner_country",
            column: "customFilterPartnerCountry",
            type: "searchSelect",
            options: computed(() => {
                const staticStore = useStatic()
                const nuxtApp = useNuxtApp()

                const countries = staticStore?.formCountries?.map((country: any) => ({
                    id: country.code,
                    name: country.name
                })) || []

                const multiLabel = nuxtApp.$i18n.t('processes.table.multiplePartners')
                return [...countries, {id: 'MULTI', name: multiLabel}]
            }),
            reduced: 'in',
            searchSelectConfig: {
                fetchOnSearch: false,
                multiple: true,
            }
        }, {
            name: "statusKey",
            column: "statuses.key",
            type: "processStatus",
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.processes.processes.statuses.index')
            ).then(response => response.data?.map(
                status => ({
                    value: status.key,
                    label: status.name_management_area
                }))
            ),
            default: {
                operator: "in",
                value: ["a_revise", "a_started", "a_received", "a_granted", "v_revise", "v_started", "v_received", "v_granted"]
            },
            reduced: true,
            multiple: true
        }, {
            name: "customFilterHasOpenPayment",
            column: "customFilterHasOpenPayment",
            type: "boolean",
            reduced: true
        }, {
            name: "event",
            column: "events.id",
            type: "shortcut",
            relation: "event"
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: "processes.create",
            isCreateAction: true,
            ability: [
                "createForAll",
                "processes"
            ]
        },
        {
            name: "processes.changeStatus",
            icon: "heroicons:chart-bar-square",
        }, {
            name: "processes.massApproval",
            icon: "heroicons:arrow-down-tray",
            ability: ["update", "processes"]
        }, {
            name: "processes.paymentRuns",
            icon: "heroicons:arrow-down-tray",
            ability: ["create", "payments"]
        }, {
            name: "processes.reporting",
            icon: "heroicons:chart-bar-square",
            ability: ["viewAny", "reporting"]
        }, {
            name: "processes.creatorUserMail",
            icon: "heroicons:envelope",
            ability: ["update", "processes"]
        }, {
            name: "processes.excelExport",
            icon: "heroicons:table-cells",
            ability: ["update", "processes"]
        }
    ],
    enableSaveFilters: true,
}